import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=3f0e71c1&scoped=true&"
import script from "./Numbers.vue?vue&type=script&lang=js&"
export * from "./Numbers.vue?vue&type=script&lang=js&"
import style0 from "./Numbers.vue?vue&type=style&index=0&id=3f0e71c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e71c1",
  null
  
)

export default component.exports